const global = {
  state: {
    accessToken: null
  },
  mutations: {
    setAccessToken (state, accessToken) {
      state.accessToken = accessToken
    },
    delAccessToken (state) {
      state.accessToken = null
    }
  },
  actions: {
    /**
     * 全局请求头（可设置Token），传参包含请求URL（附带contextPath），可做更细处理
     * 支持返回Promise
     */
    globalRequestHeaders: function (context) {
      return {
        Authorization: `Bearer ${context.state.accessToken}`
      }
    },
    /**
     * 全局请求参数（可设置access_token），传参包含请求URL（附带contextPath），可做更细处理
     * 支持返回Promise
     */
    globalActionParams: function (context) {
      return {
        access_token: context.state.accessToken
      }
    }
  }
}

export default global
